import type {VideoPlayerMetadata} from "@ok/web/models/videoPlayer/VideoPlayerMetadata";
import type {OneVideoPlayerElement} from "@ok/video-player";

export interface IOKClipsFullScreen {
    appendFirst: (item: Clip, initTarget?: HTMLDivElement) => void
    setOpenState: (state: boolean) => void
}

export enum CLIP_URLS  {
    GET = "clips/get",
    LIKE = "clips/like",
    UNLIKE = "clips/unlike",
    SUBSCRIBE = "clips/subscribe",
    RESHARE = "clips/reshare"
}
export enum URL_PARAMS {
    CLIP = "clip_id",
    OWNER = "owner_id",
}


export enum FullscreenItemType  {
    CLIP,
    STUB,
    NOT_ALLOWED,
    SKELETON,
}

export type FullScreenItem = {
    type?: FullscreenItemType;
    item?: RawFullscreenItem;
    current: boolean;
    isPrev: boolean;
    isNext: boolean;
    isSkip?: boolean;
}


export type Clip = {
    meta: VideoPlayerMetadata;
    attrsAsString: string;
    isOK: boolean;
    bundleUrl: string;
    payload: {
        complaintLink: string;
        authorInfo: AuthorInfo;
        likeInfo: LikeInfo;
    }
    marker: Marker;
    hasMore: boolean;
    isClipUnavailable: boolean;
}

export type RawFullscreenItem = Clip;


export type Marker = {
    marker?: string;
    ownerId?: number;
    source?: string;
    isEmpty: number;
}


export type LikeInfo = {
    count: number;
    userLikeSet: boolean;
    likeLink?: string;
    unlikeLink?: string;
}

export type AuthorInfo = {
    isUser: boolean;
    isOkOwner: boolean;
    firstName: string;
    lastName?: string;
    avatar: string;
    id: number;
    okId: number;
    isSubscribed: boolean;
    subscribeLink: string;
    pageUrl?: string;
}


export enum Direction {
    FORWARD,
    BACKWARD,
    INPLACE,
}

export enum ToastType {
    LOAD_ERROR,
    SUBSCRIBED,
    DISLIKED,
    RESHARE_SUCCESS,
    LINK_COPIED,
}

export type GetClipsResponse = {
    clips: Clip[];
}

export type Response = {
    status: "OK" | "ERROR",
    message?: string;
}


export type ClipInfo = {
    clipId: number;
    ownerId: number;
}

export enum AnimationType {
    FADE_IN,
    FADE_OUT,
    INSTANT
}

export type VideoPlayerNode = {
    node: OneVideoPlayerElement | null
}

export type DivExtendedByInViewportFunction = HTMLDivElement & {
    setInViewport: (state: boolean) => void
}
